import { render } from "./TourDetailsRiver.vue?vue&type=template&id=4bf2e1dd"
import script from "./TourDetailsRiver.vue?vue&type=script&lang=js"
export * from "./TourDetailsRiver.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__